import { useApi } from 'api/api-context';
import RequireGlobalPermissionPage from 'components/permissions/RequireGlobalPermissionPage';
import PredefinedDataTable from 'components/tables/data/predefined/PreDefinedDataTable';
import DashboardLayout from 'layouts/dashboard/DashboardLayout';
import { ADD_GLOBAL_PREDEFINED_DATA_PAGE_PATH, EDIT_GLOBAL_PREDEFINED_DATA_PAGE_PATH } from 'routes/paths';

/**
 * Page used to display global pre-defined data.
 */
export default function GlobalPredefinedDataPage() {
  const { getAction } = useApi();

  return (
    <RequireGlobalPermissionPage permission="manage-global-predefined-data">
      <DashboardLayout breadcrumbs={[{ title: 'Nastavenia' }, { title: 'Globálne predvolené údaje' }]} height="screen">
        <PredefinedDataTable
          action={getAction('PredefinedDataListGlobal')}
          addPath={ADD_GLOBAL_PREDEFINED_DATA_PAGE_PATH.original}
          editPath={EDIT_GLOBAL_PREDEFINED_DATA_PAGE_PATH}
          tableType="global"
        />
      </DashboardLayout>
    </RequireGlobalPermissionPage>
  );
}
